// extracted by mini-css-extract-plugin
export var modal = "_4g-0";